import { render, staticRenderFns } from "./JVxeImageCell.vue?vue&type=template&id=4d6fca2a&scoped=true"
import script from "./JVxeImageCell.vue?vue&type=script&lang=js"
export * from "./JVxeImageCell.vue?vue&type=script&lang=js"
import style0 from "./JVxeImageCell.vue?vue&type=style&index=0&id=4d6fca2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6fca2a",
  null
  
)

export default component.exports